<s1-input-select [control]="control" [itemsList]="turni" [label]="'turni.fields.turno'" [readonly]="readonly"></s1-input-select>